import { sortBy } from 'lodash';
import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const getColumns = () => [
  { propertyKey: 'line', name: i18next.t('GENERAL.LINE') },
  { propertyKey: 'name', name: i18next.t('GENERAL.PRODUCT') },
  {
    propertyKey: 'error',
    name: i18next.t('GENERAL.ERROR'),
  },
];

export const getImportErrorFileConfig = (unValidatedProducts) => {
  const sortedUnValidatedProducts = sortBy(unValidatedProducts, 'line');

  const columns = getColumns();

  const productsSheet = utilsXLS.generateDefaultSheet(
    i18next.t('GENERAL.PRODUCT_PLURAL'),
    columns,
    sortedUnValidatedProducts,
  );

  utilsXLS.makeXLS(i18next.t('_BACKEND_TRANSLATIONS.PRODUCTS.IMPORTS.IMPORT_ERROR_FILE_TITLE'), [
    productsSheet,
  ]);
};
